export default {
  login () {
    window.sessionStorage.setItem('huix-freight-admin-login', true)
  },
  setUser (user) {
    window.sessionStorage.setItem('huix-freight-admin-user', JSON.stringify(user))
  },
  setCheckYear (year) {
    window.sessionStorage.setItem('year', year)
  },
  getCheckYear () {
    const year = window.sessionStorage.getItem('year')
    return year
  },
  getUser () {
    const user = window.sessionStorage.getItem('huix-freight-admin-user')
    return user ? JSON.parse(user) : null
  },
  logout () {
    window.sessionStorage.removeItem('huix-freight-admin-login')
    window.sessionStorage.removeItem('huix-freight-admin-user')
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('year')
  },
  isLogin () {
    const loginResult = window.sessionStorage.getItem('huix-freight-admin-login')
    return loginResult || false
  }
}
